import axios from "axios";

class Api {
  constructor(Logoff) {
    this.logout = Logoff !== undefined ? Logoff : () => { };
    this.baseURL = process.env.REACT_APP_API_URL;
  }

  async Get({ url, endpoint, params, config }) {
    try {
      let response;
      let fetchConfig = { ...config }; // Copiando as opções de configuração

      // Verificando se há uma URL direta
      if (url !== undefined) {
        response = await fetch(url, fetchConfig);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
      }

      // Montando a URL com parâmetros se fornecidos
      if (params !== undefined) {
        let query = "";
        const nameParams = Object.getOwnPropertyNames(params);

        nameParams.forEach((item, i) => {
          if (i === 0) {
            query = `?${item}=${params[item]}`;
          } else {
            query += `&${item}=${params[item]}`;
          }
        });

        response = await fetch(`${this.baseURL}${endpoint}${query}`, fetchConfig);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
      }

      // Fazendo requisição sem parâmetros
      response = await fetch(`${this.baseURL}${endpoint}`, fetchConfig);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      if (error?.response?.status === 401) {
        this.logout();
      }
      throw error;
    }
  }

  async Post({ endpoint, data, config }) {
    try {
      const response = await axios.post(
        `${this.baseURL}${endpoint}`,
        data,
        config
      );
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this.logout();  // Tratamento específico para erro 401 (não autorizado)
      } else {
        console.error('Erro na requisição POST:', error.response || error.message);
      }
      throw error;  // Re-lança o erro para ser tratado no chamador
    }
  }

  async Put({ endpoint, data, config }) {
    try {
      const response = await axios.put(
        `${this.baseURL}${endpoint}`,
        data,
        config
      );
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this.logout();
      }
      throw error;
    }
  }

  async Patch({ endpoint, data, config }) {
    try {
      const response = await axios.patch(
        `${this.baseURL}${endpoint}`,
        data,
        config
      );
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this.logout();
      }
      throw error;
    }
  }


  async Delete({ endpoint, params, config }) {
    try {
      if (params !== undefined) {
        let query = "";
        const nameParams = Object.getOwnPropertyNames(params);

        nameParams.forEach((item, i) => {
          if (i === 0) {
            query = `?${item}=${params[item]}`;
          } else {
            query += `&${item}=${params[item]}`;
          }
        });

        const response = await axios.delete(
          `${this.baseURL}${endpoint}${query}`,
          config
        );
        return response.data;
      }
      const response = await axios.delete(`${this.baseURL}${endpoint}`, config);
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        this.logout();
      }
      throw error;
    }
  }
}

export default Api;
